import React from 'react';
import { useLocation } from 'react-router-dom';
import TopBar from './component/TopBar';

function CreditReport() {
  const location = useLocation();
  const id = new URLSearchParams(location.search).get('id');

  return (
    <div className="app-page">
      <TopBar title="Credit Report" backPath={`/CustomerEmiPage?id=${id}`} />

      <div className="app-content">
        <div className="app-card" style={{ textAlign: 'center', padding: 32 }}>
          <div style={{ fontSize: 52, marginBottom: 12 }}>📋</div>
          <p style={{ fontSize: 18, fontWeight: 700, color: '#1d2e77', marginBottom: 8 }}>
            CIBIL Credit Report
          </p>
          <p style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
            Check your free credit report from PNB.
          </p>
          <a
            href="https://www.pnbindia.in/Free-Credit-Report.html"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary-app"
            style={{ display: 'block', textDecoration: 'none', textAlign: 'center', lineHeight: '50px', marginBottom: 0 }}
          >
            Check Credit Report
          </a>
        </div>
      </div>
    </div>
  );
}

export default CreditReport;
